<template lang="pug">
  .v-container(:class="modalClass")
    .h3.u-weight-bold Use TOM Points
    hr.c-hr
    .p-checkout-point-header.u-flex.u-flex-jc-space_between.u-flex-ai-center.u-mbm
      .u-fs-lg
        | TOM Points remaining:
        span.bold.u-mlxs.u-mrxs {{(ShoppingCarts.availablePoint(cart, user) - point) | currency}}

      .p-checkout-point-header__right.u-flex.u-flex-jc-space_between.u-flex-ai-center(v-if="user.revivable_right && user.revivable_right.expiredDollar > 0")
        i.icon-comment.u-fs-xxl.u-color--point-lv2
        .u-mls
          | You have {{user.revivable_right.expiredDollar | currency}} in expired TOM Points that can be recovered.
          br
          a(href="/premium/join/main?via=shop_checkout", target="_blank", onclick="tom.helper.ga.push(['event', 'Premium', 'Clicked', 'Cart_PointsWillBeRecoverd', 1]);") Join TOM Premium
          span.u-mlxs and your points will be recovered automatically.

    // ポイント選択・入力
    .p-checkout-point.u-mbm
      .c-message.c-message--danger.u-mt0(v-if="errors.has('point')")
        p {{errors.first('point')}}

      div
        .u-fs-lg.u-weight-bold.u-flex.u-flex-ai-center
          .u-mrs Use
          .u-mrs
            .input--addon-postfix.input--icon-prefix(style='max-width:14em;')
              i.icon-dollar
              input.form-ctl.form-ctl--lg.p-cart-form__use-point.u-color--point-lv2(
                type="text",
                name="point",
                v-model="point",
                v-validate="'required|point|min_point|max_point'",
                data-vv-as="point",
                maxlength="9",
                style="width: 120px; border-right-width: 2px;"
                )
          div TOM Points

      .p-checkout-point-options.u-mtm
        div Options:
        ul.u-mb0.u-mlxs.p-checkout-point-options__items
          li.u-mlxs.u-mrxs.p-checkout-point-options__items__item
            button.c-btn.c-btn--sm.c-btn--secondary.c-btn--round.c-btn--inverse.u-wrap(type="button", @click.prevent="changeUsePoint(maxPoint)")
              | Use #[strong {{maxPoint | currency}}] TOM Points (the max amount possible)
          li.u-mlxs.u-mrxs.p-checkout-point-options__items__item
            button.c-btn.c-btn--sm.c-btn--secondary.c-btn--round.c-btn--inverse.u-wrap(type="button", @click.prevent="changeUsePoint(0)")
              | Use #[strong $0.00] TOM Points

    .u-mtm
      p.u-fs-sm.u-color-gray
        | Not applicable to shipping fees. TOM Points and any discounts used will affect your order subtotal, which determines your total earned TOM Points, and can affect shipping promotions as well. There is a percentage cap on Points that can be used per order: 50% of the Product Subtotal for Premium members, and 20% for non-Premium members.
      p.u-fs-sm.u-color-gray(v-if="cart.reserved_point")
        | TOM Points will be automatically withdrawn for any Premium Point Reward items in your cart.
    .u-mtm.u-align-right.u-align-center--sm
      button.c-btn.c-btn--primary.c-btn--lg.c-btn--link(type="submit", @click="onCancel") Cancel
      button.c-btn.c-btn--primary.c-btn--lg(type="button", @click="onSubmit", :disabled="errors.has('point')") Continue

    hr.c-hr

    div
      p
        | Q:
        a.u-mlxs(href="https://otakumode.com/hc/shop/shop_information/shop_information_points_coupons/5885af7ee423c31a117ff5fe", target="_blank")
          | What are TOM Points?
</template>

<script>
  import textUtil from '../../util/text';
  import ShoppingCarts from '../../stores/schema/ShoppingCarts';
  export default {
    name: 'CheckoutPoints',
    data() {
      return {
        point: 0
      };
    },
    filters: {
      currency: textUtil.currency
    },
    computed: {
      cart() {
        return this.$store.getters['cart/current']();
      },
      user() {
        return this.$store.state.user;
      },
      wishlistId() {
        return this.cart.wishlistId;
      },
      maxPoint() {
        return Math.min(this.cart.max_usable_tom_point, ShoppingCarts.availablePoint(this.cart, this.user));
      },
      ShoppingCarts() {
        return ShoppingCarts;
      },
      modalClass() {
        return {
          'v-container--modal': this.user.is_smart_phone_device
        };
      }
    },
    methods: {
      onCancel() {
        this.$router.push('/checkout/review');
      },
      onSubmit() {
        this.$validator.validateAll(this.scopeName).then(result => {
          if (result) {
            this.$store.dispatch('cart/updatePoint', {
              wishlist_id: this.wishlistId,
              point: this.point
            })
            .then(() => {
              this.$router.push('/checkout/review');
            })
            .catch((err) => {
              this.$alert(err.general || 'An error occurred. Please wait a moment before trying again.');
            });
          }
        });
      },
      addCustomValidationRule() {
        // 空欄かどうかをチェック
        this.$validator.extend('required', {
          getMessage: () => 'Please input a point value or select one of the options below the input box.',
          validate: value => !!String(value)
        });

        // decimalかどうかをチェック
        this.$validator.extend('point', {
          getMessage: () => 'The TOM Points field only accepts numbers (with up to 2 digits after the decimal).',
          validate: value => {
            return /^\d+(\.?)(\d{1,2})?$/.test(value);
          }
        });

        // 最小ポイントかどうかをチェック
        this.$validator.extend('min_point', {
          getMessage: () => 'The point must be 0 or more.',
          validate: value => (value >= 0)
        });

        // 最大ポイントかどうかをチェック
        this.$validator.extend('max_point', {
          getMessage: () => `${textUtil.currency(this.maxPoint)} TOM Points is the maximum amount you can use on this order.`,
          validate: value => (value <= parseFloat(this.maxPoint, 10))
        });
      },
      changeUsePoint(point) {
        this.point = point;
      }
    },
    created() {
      this.point = this.cart.point;

      this.addCustomValidationRule();
    }
  };
</script>

<style scoped>
  .v-container {
    padding: 20px;
  }

  .v-container.v-container--modal {
    padding: 0;
  }

  .p-checkout-point {
    padding: 30px;
    border: 1px solid #D0D0D0;
  }

  .p-checkout-point-options {
    align-items: center;
    display: flex;
  }

  .p-checkout-point-options__items {
    display: flex;
  }

  @media (max-width: 767px) {
    .p-checkout-point {
      padding: 20px;
    }

    .p-checkout-point-options {
      align-items: flex-start;
    }

    .p-checkout-point-options__items {
      flex-direction: column;
    }

    .p-checkout-point-options__items__item + .p-checkout-point-options__items__item {
      margin-top: 8px;
    }

    .p-checkout-point-header {
      flex-direction: column;
    }

    .p-checkout-point-header__right {
      margin-top: 20px;
    }
  }
</style>
